import booking from '@/api/booking/table-booking'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  tableList: [],
  schedules: [],
  customers: [],
  bookingDate: moment().format('DD-MM-YYYY')
}

export const getters = {
    getDescription: state =>({ table_id, schedule_id }) => {
        return state.resources.filter(
            r => r.table_id == table_id && 
            r.schedule_id == schedule_id &&
            r.is_cancel == false
        )
        .reduce((i, v) => {
          return i = (v.customer ? v.customer.customer_name : '') + ' ' + (v.customer ? v.customer.contact_number : '')
        } , '')
    },
    getBookingId: state => ({ table_id, schedule_id }) => {
      return state.resources.filter(
          r => r.table_id == table_id && 
          r.schedule_id == schedule_id &&
          r.is_cancel == false
      )
      .reduce((i, v) => i = v.booking_id , 0)
    },
    getRef: state => ({ tableId, scheduleId }) => {
      return state.resources.filter(
        r => r.table_id == tableId &&
        r.schedule_id == scheduleId
      )
      .reduce((i, v) => i = v.booking_ref_id , 0)
    },
    customerBooking: state => ({ tableId, referenceId }) => {
      return state.resources.filter(
        r => r.table_id == tableId && r.booking_ref_id == referenceId
      )
    }
}

export const mutations = {
  ...baseMutations,
  SET_TABLE_LIST(state, data){
    state.tableList = data
  },
  SET_SCHEDULE_LIST(state, data){
    state.schedules = data
  },
  SET_BOOKING_DATE(state, data){
    state.bookingDate = data
  },
  SET_CUSTOMER_LIST(state, data){
    state.customers = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
            booking_date: context.state.bookingDate
        }
      },
      attrubutes
    )
    return booking.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return booking.store(data)
  },
  destroy(context, id){
    return booking.destroy(id)
  },
  async getTable(context){
    let response = await booking.table()
    context.commit('SET_TABLE_LIST', response.data)
    return response
  },
  async getSchedule(context){
    let response = await booking.schedule()
    context.commit('SET_SCHEDULE_LIST', response.data)
    return response
  },
  async getCustomer(context){
    let response = await booking.customer()
    context.commit('SET_CUSTOMER_LIST', response.data)
    return response
  }
}